import { useDeprecation as o } from "./useDeprecation.js";
function t(e) {
  o(e);
}
export {
  t as useComponentDeprecation
};
